/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.LogisticsGroupAttrModel>>;
export function request(
  body: defs.basics.LogisticsGroupAttrRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/logisticsGroupAttr/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
